import {mount} from "./mount";
import {FlowBuilderSettings} from "@/config/flowBuilderSettings";

interface FlowBuilderProps {
  containerId: string;
  jwt: string;
  modelId: string;
  backendENV?: string;
  demoMode?: boolean;
  minimapEnabled?: boolean;
  demoData?: {
    nodes: any[];
    edges: any[];
  };
  onModeChange?: () => void;
}

declare global {
  interface Window {
    FlowBuilder: {
      init: (props: FlowBuilderProps) => void;
    };
  }
}

const FlowBuilder = {
  init: ({
    containerId,
    jwt,
    modelId,
    backendENV,
    demoMode = false,
    minimapEnabled = true,
    demoData,
    onModeChange,
  }: FlowBuilderProps) => {
    FlowBuilderSettings.jwt = jwt;
    FlowBuilderSettings.modelId = modelId;
    FlowBuilderSettings.backendENV = backendENV;
    FlowBuilderSettings.demoMode = demoMode;
    FlowBuilderSettings.minimapEnabled = minimapEnabled;
    FlowBuilderSettings.demoData = demoData;
    FlowBuilderSettings.onModeChange = onModeChange;
    mount(containerId);
  },
};

window.FlowBuilder = FlowBuilder;

export default FlowBuilder;
